export const mediaExtensions = {
  image: ['jpg', 'jpeg', 'png', 'gif', 'webp', 'avif', 'bmp', 'svg', 'ico', 'tif', 'tiff', 'heic', 'heif'],
  video: ['webm', 'mp4', 'm4v', 'mov', 'avi', 'mkv', 'ogv', 'mpeg', 'mpg', '3gp'],
  audio: ['mp3', 'wav', 'ogg', 'oga', 'opus', 'flac', 'aac', 'm4a', 'aiff'],
} as const;

export type FileCategory = keyof typeof mediaExtensions | 'other';

export function fileCategory(mime: string | null, name: string): FileCategory {
  const type = (mime ?? '').trim().toLowerCase().split('/')[0];
  if (type === 'image' || type === 'video' || type === 'audio') return type;
  const extension = name.includes('.') ? name.split('.').pop()!.toLowerCase() : '';
  for (const category of ['image', 'video', 'audio'] as const) {
    if ((mediaExtensions[category] as readonly string[]).includes(extension)) return category;
  }
  return 'other';
}

export const fileCategorySql = `CASE
  WHEN lower(trim(mime_type)) LIKE 'image/%' THEN 'image'
  WHEN lower(trim(mime_type)) LIKE 'video/%' THEN 'video'
  WHEN lower(trim(mime_type)) LIKE 'audio/%' THEN 'audio'
  ${Object.entries(mediaExtensions).map(([category, extensions]) =>
    `WHEN lower(original_name) ~ '[.](${extensions.join('|')})$' THEN '${category}'`).join('\n  ')}
  ELSE 'other' END`;
